import React, { SVGProps } from 'react';
import { ReactComponent as UAE } from './uae.svg'

const SvgCustomTurkey = (props: SVGProps<SVGSVGElement>) => (
	<UAE></UAE>
);

export default SvgCustomTurkey;
